import styled from 'styled-components'
import projectThumbnail from '@images/project_thumbnail.jpg'
import colorsOptions from '../stories/fundamentals/colors-styles/constants'
import {
  textStyleSizeOptions,
  textStyleSizeStyleOptions,
  textStyleWeightOptions,
  textStyleWeightStyleOptions
} from '../stories/fundamentals/text-styles/constants'

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`

export const NotFoundContainer = styled(LoadingContainer)`
  flex-direction: column;
  padding: 1rem;
`

export const NotFoundContent = styled(LoadingContainer)`
  padding: 1rem;
`

export const ContentContainer = styled.div`
  flex: 1;
  width: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 5.5rem 1rem 0;
  height: 100%;
`

export const ProjectInfoSectionTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 0 0.5rem;
`

export const ProjectInfoSectionTitle = styled.div`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-XL']]}
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]};
  color: ${colorsOptions.greys['grey-90']};
`

// Header
export const HeaderContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 240px;
  padding: 1rem;

  background-image:
    linear-gradient(
      180deg,
      rgba(20, 26, 33, 0.2) 20%,
      rgba(20, 26, 33, 0.8) 80%
    ),
    url(${({ background }) => background}), url(${projectThumbnail});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`

export const HeaderButtons = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
`

export const ProjectIdentification = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 1rem 0 1.5rem 1rem;
  flex: 1;
`

export const ProjectCompany = styled.span`
  color: ${colorsOptions.greys.white};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]}
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]}
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`

export const ProjectTitle = styled.span`
  color: ${colorsOptions.greys.white};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-XL']]}
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]}
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`

export const ProjectSummaryContainer = styled.div`
  position: absolute;
  bottom: -5rem;
  left: 0;
  width: 100%;

  display: flex;
  flex-direction: row;
  padding: 0 1rem;
  gap: 0.5rem;
`

export const ProjectSummaryItem = styled.div`
  background: ${colorsOptions.greys.white};
  border: 1px solid ${colorsOptions.greys['grey-10']};
  box-shadow: 0px 5px 10px 10px rgba(0, 0, 0, 0.02);
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  border-radius: 8px;
  width: 100%;
  flex: 1;
  cursor: pointer;

  &:hover {
    background: ${colorsOptions.greys['grey-20']};
  }

  &:active {
    background: ${colorsOptions.greys['grey-30']};
  }
`

export const ProjectSummaryItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  align-items: center;
`

export const ProjectSummaryLabel = styled.span`
  color: ${colorsOptions.greys['grey-100']};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]}
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]}
`

export const ProjectSummaryValue = styled.span`
  color: ${colorsOptions.greys['grey-100']};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]}
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]}
`

// Info

export const ProjectDetailsInfoContainer = styled.div`
  padding: 1rem 0;
  display: flex;
  flex-direction: column;
`

export const InfoItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`

export const InfoItem = styled.div`
  flex: 1 1 50%;
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0.5rem 0.5rem 0;
`

export const InfoLabel = styled.span`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-XS']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  color: ${colorsOptions.greys['grey-70']};
`

export const InfoValue = styled.span`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  color: ${colorsOptions.greys['grey-100']};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

export const Divisor = styled.div`
  width: 100%;
  height: 1px;
  background: ${colorsOptions.greys['grey-20']};
  margin: 0.5rem 0;
`

export const InfoValueDescription = styled(InfoValue)`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  display: -webkit-box;
  -webkit-line-clamp: ${({ isExpanded }) => (isExpanded ? 'unset' : 3)};
  -webkit-box-orient: vertical;
  overflow: hidden;

  ${({ isExpanded }) =>
    isExpanded &&
    `
    display: block;
    overflow: auto;
    max-height: 250px;
  `}
`

export const ReadMore = styled.span`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  color: ${colorsOptions.docuToolsOrange.orange};
  cursor: pointer;
`

// project pagination

export const ProjectPaginationContainer = styled.div`
  width: 100%;
  height: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  z-index: 2;
  background-color: ${colorsOptions.greys['grey-10']};
  padding: 0.5rem;
`

export const PaginationCount = styled.span`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]}
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]}
  color: ${colorsOptions.greys['grey-90']};
`

// project members
export const ProjectMembersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1;
  min-height: 0;
`

export const ProjectMembersTabsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`

export const ProjectMembersTabsContent = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${colorsOptions.greys.white};
  border: 1px solid ${colorsOptions.greys['grey-20']};
  border-top: 0;
  border-radius: 0 0 16px 16px;
  flex: 1;
  min-height: 0;
`

export const ProjectMembersTabTitle = styled.div`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
  ${({ isActive }) =>
    isActive
      ? textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]
      : textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
`

export const ProjectMembersTabEmptyMembersContainer = styled.div`
  padding: 5rem 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ProjectMembersTabMembersContainer = styled.div`
  flex: 1;
  min-height: 200px;
  overflow-y: auto;
  border-radius: 0 0 16px 16px;
  scrollbar-width: none;
`
